import styled from 'styled-components/macro';
import { Container } from '@yme/atoms/grid';
import { colorAccentSuccess500, colorCoreWhite1000 } from '@yme/tokens/colors';
import { elevationTopLvl2 } from '@yme/tokens/elevations';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { Z_INDEX } from '@yme/tokens/zindex';
export const ContainerStyled = styled(Container) `
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: ${Z_INDEX.level7};
  padding: 16px;
  box-sizing: border-box;

  background-color: ${colorCoreWhite1000};
  box-shadow: ${elevationTopLvl2};

  div {
    margin: 0;
  }
`;
export const FlexWrapperContainer = styled(FlexWrapper) `
  ${({ isMobileView }) => isMobileView &&
    `
    flex-direction: column;
    gap: 16px;
  `}
`;
export const ForwardButtonContainerStyled = styled.div `
  svg > path {
    fill: ${colorAccentSuccess500};
  }

  display: flex;
  justify-content: space-between;
`;
export const ReimbursementWrapperStyled = styled.div `
  width: 100%;
`;
